import { createFileRoute, Navigate } from "@tanstack/react-router"

export const Route = createFileRoute(
  "/_authenticated/_organization/communication/"
)({
  component: () => <Navigate to="/communication/announcements" />,
})
